import React, { Fragment, useEffect, useState } from "react";
import { Row, Card, Tab, Nav, Modal, Spinner, Button } from "react-bootstrap";
import { TableDocument, DocumentText, Video, Star, ArrangeHorizontal, Information, Calendar} from "iconsax-react";
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import FormIDSMaestro from "../../../../components/Maestri/profilo/formIDSMaestro";
import VideoMaestro from "../../../../components/Maestri/profilo/videoMaestro";
import SportMaestro from "../../../../components/Maestri/profilo/sportMaestro";
import FeedbackMaestro from "../../../../components/Maestri/profilo/feedbackMaestro";
import DisponibilitaMaestro from "../../../../components/Maestri/profilo/disponibilitaMaestro";
import { usePageTitle, useStatoInSolaLettura, statoProfilo } from "../../../../layouts/PageHeaderExtra";
import MyApiClient from "../../../../../api-client/MyApiClient";
import DynamicLogo from "../../../DynamicLogoLoader";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";

const MaestroEdit = () => {

	const { id } = useParams();

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [profile, setProfile] = useState(null);
	const [labelNome, setLabelNome] = useState('');
	// Titolo della pagina = nome e cognome, appena caricati.
	usePageTitle(labelNome);
	// Stato del profilo in sola lettura accanto al titolo (manca l'API per cambiarlo)
	const statoProf = statoProfilo(profile?.idsGuru?.profileStatus);
	useStatoInSolaLettura(statoProf.label, statoProf.tono);

	const navigate = useNavigate();
	// «Elimina»: era nel menu a fine riga della lista, ora sta nella scheda (03/10/2026).
	const [confermaElimina, setConfermaElimina] = useState(false);
	const [erroreElimina, setErroreElimina] = useState('');

	const eliminaMaestro = async () => {
		setConfermaElimina(false);
		const tokenDetailsString = sessionStorage.getItem('userDetails');
		if (!tokenDetailsString) return;
		const token = JSON.parse(tokenDetailsString).idToken;
		setLoadingShowed(true);
		const deleteResult = await new MyApiClient().deleteProfile(token, id);
		setLoadingShowed(false);
		if (deleteResult) {
			setErroreElimina(deleteResult);
		} else {
			navigate('/superadmin/anagrafiche/maestri');
		}
	};
	
    const tabData = [
		{
			name: "Informazioni",
			icon: <TableDocument size='18' variant='Bulk' />,
			content: <FormIDSMaestro isDisabled={true} profile={profile} />,
		},
		{
			name: "Video di presentazione",
			icon: <Video size='18'  />,
			content: <VideoMaestro profile={profile}/>,
		},
		{
			name: "Sport",
			icon: <DocumentText size='18' />,
			content:<SportMaestro profile={profile} puoEliminare={true} />,
		},
		{
			name: "Disponibilità",
			icon: <Calendar size='18' variant='Bulk' />,
			content:<DisponibilitaMaestro profile={profile} readonly={true}/>,
		},
		{
			name: "Feedback",
			icon: <Star size='18' />,
			content:<FeedbackMaestro profile={profile}/>,
		}/*,
		{
			name: "Note private",
			icon: <Note size='18' variant="Bulk" />,
			content:<NoteMaestro/>,
		},*/
	];

	const location = useLocation();
    const query = new URLSearchParams(location.search);
    const [defaultTab, setDefaultTab] = useState(query.get('tab') || tabData[0].name.toLowerCase());

    useEffect(() => {
        const tab = new URLSearchParams(location.search).get('tab');
		if (tab && tab !== defaultTab) {
            setDefaultTab(tab);
        }
    }, [location.search, defaultTab]);

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const [profileData] = await Promise.all([
                        apiClient.getProfiles(token, id)
                    ]);
					setLoadingShowed(false);

					let labelNomeTemp = '';
					if(profileData.idsGuru) {
						labelNomeTemp = profileData.idsGuru.givenName+' '+profileData.idsGuru.familyName;
					}
					setLabelNome(labelNomeTemp);

					setProfile(profileData);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id]);

	const isNotCompleted = profile && profile.idsGuru.profileStatus !== 'COMPLETED' && profile.idsGuru.profileStatus !== 'ACTIVE';

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<div className="custom-tab-1">
				<Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link eventKey={data.name.toLowerCase()}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-xl-9">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
							{/* Azioni del maestro: in fondo alla scheda, l'eliminazione a sinistra. */}
							<div className="d-flex justify-content-between mt-4">
								<Button className="btn btn-danger btn-add" onClick={() => setConfermaElimina(true)}>Elimina maestro</Button>
								<button type="button" className="btn btn-light btn-add" onClick={() => navigate('/superadmin/anagrafiche/maestri')}>Indietro</button>
							</div>
						</div>
						<div className="col-xl-3">
							<Card>
								<Card.Body className="text-center">
									{profile && profile.idsGuru.picture && <DynamicLogo logoUrl={profile ? profile.idsGuru.picture : ''} altText="Logo Staff Tecnico" />}
									{(!profile || !profile.idsGuru.picture) && <img src={DEFAULT_USER} style={{width: '100%'}} alt="Logo Staff Tecnico" />}
									<h4 className="text-start mb-0 mt-4 text-warning">{labelNome}</h4>
									{/*<p className="text-start mt-0 pt-0">Staff Tecnico</p>*/}
									{profile && <Link to={'/superadmin/anagrafiche/player/'+profile.idsGuru.userId} className="btn btn-sm btn-booking"><ArrangeHorizontal variant="Bulk" /><span className='ms-2'>Visualizza profilo player</span></Link>}
									
									{isNotCompleted && (
									<Link to={'#'} className="btn btn-sm btn-profile mt-2">
										<Information variant="Bulk" /><span className='ms-2'>Profilo non completato</span>
									</Link>)}
								</Card.Body>
							</Card>
						</div>
					</Row>
				</Tab.Container>
			</div>

			<Modal className="fade" show={confermaElimina} onHide={() => setConfermaElimina(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Eliminare il maestro?</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Eliminare il maestro «{labelNome || 'senza nome'}»? L'operazione non si può annullare.
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => setConfermaElimina(false)}>Annulla</Button>
					<Button className="btn btn-danger btn-add" onClick={eliminaMaestro}>Elimina</Button>
				</Modal.Footer>
			</Modal>

			<Modal className="fade" show={!!erroreElimina} onHide={() => setErroreElimina('')} centered>
				<Modal.Header closeButton>
					<Modal.Title>Errore durante l'operazione</Modal.Title>
				</Modal.Header>
				<Modal.Body>{erroreElimina}</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<Button className="btn btn-primary btn-add" onClick={() => setErroreElimina('')}>Chiudi</Button>
				</Modal.Footer>
			</Modal>

		</>
	)
}
export default MaestroEdit;